// extracted by mini-css-extract-plugin
export default {"vibrate":"taskViewTableData_vibrate__p4c1o","blink":"taskViewTableData_blink__pbXXe","hoverEffect":"taskViewTableData_hoverEffect__+lARQ"};